module.exports = __webpack_public_path__ + "img/yesterday.0caccc78.png";